import React, { useState, useEffect, useRef }  from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import Constants from '../../../definitions/constants';
import EngineFunctionsDefinition from '../../../definitions/engineFunctionsDefinition';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import $ from 'jquery';

import GlassPopup from '../common/interface/glassPopup';
import FieldInfo from '../common/inputs/fieldInfo';
import DraggableList from '../common/interface/draggableList';
import Spinner from '../common/interface/spinner';
import Button from '../common/inputs/button';
import CheckBox from '../common/inputs/checkBox';
import FormulaPolynomialEditor from './entityEditors/formulaPolynomialEditor';
import FormulaPolynomialTableEditor from './entityEditors/formulaPolynomialTableEditor';
import FormulaMetricEditor from './entityEditors/formulaMetricEditor';
import FormulaFunctionEditor from './entityEditors/formulaFunctionEditor';
import FormulaInMetricFakeFunctionEditor from './entityEditors/formulaInMetricFakeFunctionEditor';

const FormulaInput = props => {
  const {
    className,
    test,
    index,
    parentId,
    inputsChainIndex,
    value,    
    disabled,    
    disabledOnlyInput,
    onlyLeft,
    onDragOver,
    onDragEndOnTarget,
    onMouseOutEditorElement,
    handleOnChangeInner,
    handleFormulaCursorDown,
    handleFormulaCursorUp,
    handleOnClick,
    handleCopyPaste,
    onClickFormulaEditorAction,
    onlyAcceptOneObject,
  } = props;
  if(disabled) {
    return (
      <div
        key={index}
        className={"formula_editor_row_element" + (className ? " " + className : "")}
      >
        <input 
          className="input"
          type="textbox"
          id={"input-chain-" + parentId + (inputsChainIndex)}
          value={value}
          tabIndex="-1"
          disabled={true}
        />
      </div>
    );
  }
  return (
    <div
      key={index}
      data-test={test}
      data-index={index}
      data-parentid={parentId}
      data-onlyleft={onlyLeft ? "1" : ""}
      data-onlyacceptoneobject={JSON.stringify(onlyAcceptOneObject)}
      className={"formula_editor_dropable_row_element formula_editor_row_element" + (onlyAcceptOneObject!=null ? " formula_editor_dropable_row_element_only_one_object" : "") + (className ? " " + className : "")}
      onMouseMove={onDragOver}
      onMouseUp={onDragEndOnTarget}
      onMouseOut={onMouseOutEditorElement}
      onClick={onClickFormulaEditorAction}
    >
      <div className="formula_editor_row_element_decorator"><i className="fas fa-chevron-circle-down"></i></div>
      <div className="formula_editor_row_element_mark_left_decorator"><i className="fas fa-chevron-circle-down"></i></div>
      <div className="formula_editor_row_element_mark_right_decorator"><i className="fas fa-chevron-circle-down"></i></div>
      <input 
        className="input"
        type="textbox"
        id={"input-chain-" + parentId + (inputsChainIndex)}
        value={value}
        data-inputchainindex={inputsChainIndex}
        data-index={index}
        data-parentid={parentId}
        onChange={handleOnChangeInner}
        onKeyDown={handleFormulaCursorDown}
        onKeyUp={handleFormulaCursorUp}
        onClick={handleOnClick}
        onCut={handleCopyPaste}
        onCopy={handleCopyPaste}
        onPaste={handleCopyPaste}
        tabIndex="-1"
        autoComplete="off"
        disabled={onlyAcceptOneObject!=null || disabledOnlyInput}
      />
    </div>
  )
};

const FormulaEditorPopup = props => {
  const isHoldingKey = useRef(false);
  const focusOnEnd = useRef(false);
  const changedAdd = useRef(false);
  const [queueKeyEvents, setQueueKeyEvents] = useState([]);
  const focusIndex = useRef(null);
  const parentId = useRef(null);
  const [checkQueue, setCheckQueue] = useState(true);
  const deleteMode = useRef(false);
  const backSpaceMode = useRef(false);
  const [showMarkLabels, setShowMarkLabels] = useState(false);
  const {
    handleShowPopup,
    fullLoading,
    notRender,
    formulaToEditObject,
    formulaEditorOptions,
    handleValidateAndSet,
    validationStatus,
    markModeData,
    copyData,
    cutData,
    isPasting,
    copiedFormula,
    handleControlButtons,
    onDragStart,
    onDragEnd,
    onDragEndOnTarget,
    onDragOver,
    onClickFormulaEditorAction,
    onChangeText,
    onClickEntity,
    formulaEditorEditingEntityId,
    onEditEntityEditor,
    onCloseEntityEditor,    
    handleChangeCollapseEntity,
    handleChangeCollapseAllEntity,
    handleDeleteEntity,
    polynomialsList,
    metricsList,
    dimensionsList,
    functionsList,
    calendarsList,
    dimensionInstancesOptions,
    dimensionInstancesFetch,
    dimensionInstancesLoading,
    handleImportFormulaGrammarPopup,
    escBehaviourHandler,
    formulaEditorHideDraggables,
    handleHideEditorDraggables,
    popupState,
  } = props;
  
  const onMouseOutEditorElement = (event) => {
    let target = event.currentTarget;
    target.classList.remove("formula_editor_highlight_left");
    target.classList.remove("formula_editor_highlight_right");
  };
  
  const handleCopyPaste = (event) => {
    event.preventDefault();
  };
  
  // handleFormulaCursorDown -> handleOnChangeInner -> useEffect changedAdd -> handleFormulaCursorUp
  const handleFormulaCursorDown = (event) => {
    let admittedRegex = /[0-9\.%+-/*\(\)]/gi;
    let targetChar = event.key ? event.key : String.fromCharCode(event.charCode);
    if (event.keyCode == 32 || event.keyCode == 13 || event.repeat) {
        event.preventDefault();
        return false;
    }
    //reset modes just in case a delete operation is still open
    if(deleteMode.current || backSpaceMode.current) {
      deleteMode.current = false;
      backSpaceMode.current = false;
    }
    if(isHoldingKey.current) {
      event.preventDefault();
      if(targetChar.match(admittedRegex)) {
        let newQueueKeyEvents = JavascriptUtilsTooling.deepCopy(queueKeyEvents);
        newQueueKeyEvents.push(targetChar);
        setQueueKeyEvents(newQueueKeyEvents);
      }
      return false;
    }
    if(event.keyCode != 16 && event.keyCode != 17 && event.keyCode != 18 && event.keyCode != 9) {
      isHoldingKey.current = true;
    }
    if (event.keyCode == 37) { //left      
      let inputChainIndex = +event.currentTarget.dataset.inputchainindex;
      let inputChainId = "#input-chain-" + event.currentTarget.dataset.parentid;
      let startPosition = event.currentTarget.selectionStart;
      let inputChainIdLeft = inputChainId+(inputChainIndex-1);
      let inputChainIdRight = inputChainId+(inputChainIndex+1);
      let elementRight = $(inputChainIdRight);
      let elementToFocus = $(inputChainIdLeft);
      if(elementRight.length==0 && startPosition==1) {
        event.currentTarget.setSelectionRange(0,0);
      }
      else if(elementToFocus.length>0) {
        elementToFocus[0].focus();      
        elementToFocus[0].setSelectionRange(0,0);
      }
      event.preventDefault();
    }
    else if(event.keyCode == 39) { //right      
      let inputChainIndex = +event.currentTarget.dataset.inputchainindex;
      let inputChainId = "#input-chain-" + event.currentTarget.dataset.parentid;
      let startPosition = event.currentTarget.selectionStart;
      let inputChainIdRight = inputChainId+(inputChainIndex+1);
      let elementToFocus = $(inputChainIdRight);
      if(elementToFocus.length>0) {
        elementToFocus[0].focus();
        elementToFocus[0].setSelectionRange(0,0);
      }
      else {
        focusOnEnd.current = true;
        event.currentTarget.setSelectionRange(1,1);
      }
      event.preventDefault();
    }
    else if(event.keyCode == 8) { //backspace
      let inputChainIndex = +event.currentTarget.dataset.inputchainindex;
      let inputChainId = "#input-chain-" + event.currentTarget.dataset.parentid;
      let inputChainIdLeft = inputChainId+(inputChainIndex-1);
      let elementToFocus = $(inputChainIdLeft);
      if(elementToFocus.length>0 && elementToFocus[0].value!="") {
        let newEvent = {};
        newEvent.currentTarget = elementToFocus[0];
        newEvent.currentTarget.value = "";
        onChangeText(newEvent);
        backSpaceMode.current = true;
        focusIndex.current = inputChainIndex-1;
        parentId.current = event.currentTarget.dataset.parentid;
      }
    }
    else if(event.keyCode == 46) { //delete
      deleteMode.current = true;
    }
    else if(!targetChar.match(admittedRegex)) {
      event.preventDefault();
      return false;
    }
  };
  
  //fire onchange event
  const handleOnChangeInner = (event) => {
    let newValueLength = event.currentTarget.value.length;
    let startPosition = event.currentTarget.selectionStart;
    if(!backSpaceMode.current) {
      onChangeText(event);
    }
    if(deleteMode.current) {
      focusIndex.current = +event.currentTarget.dataset.inputchainindex;
      parentId.current = event.currentTarget.dataset.parentid;
    }
    else if(newValueLength >= 1) {
      changedAdd.current = true;
      focusIndex.current = +event.currentTarget.dataset.inputchainindex;
      parentId.current = event.currentTarget.dataset.parentid;
      if(startPosition==2) {
        focusOnEnd.current = true;
      }
    }
  };
  
  const handleFormulaCursorUp = (event, queue = queueKeyEvents) => {
    if (event.keyCode == 37 || event.keyCode == 39) {
      if(!focusOnEnd.current) {
        event.currentTarget.setSelectionRange(0,0);
      }
      else {
        focusOnEnd.current = false;
        event.currentTarget.setSelectionRange(1,1);        
      }
      event.preventDefault();
    }
    if(queueKeyEvents.length==0) {
      isHoldingKey.current = false;
    }
  };
  
  useEffect(() => {
    if(changedAdd.current) {
      let inputChainIndex = focusIndex.current;
      let inputChainId = "#input-chain-" + parentId.current;
      let inputChainIdRight = inputChainId+(inputChainIndex+1);
      let elementRight = $(inputChainIdRight);
      if(elementRight.length>0) {
        elementRight[0].focus();
        if(!focusOnEnd.current) {
          elementRight[0].setSelectionRange(0,0);
        }
        else {
          elementRight[0].setSelectionRange(1,1);
          focusOnEnd.current = false;
        }
      }      
      changedAdd.current = false;      
      focusIndex.current = null;
      parentId.current = null;
      setCheckQueue(true);
    }
    else if(deleteMode.current) {
      let inputChainId = "#input-chain-" + parentId.current + focusIndex.current;
      let elementFocus = $(inputChainId);
      if(elementFocus.length>0) {
        elementFocus[0].focus();
        elementFocus[0].setSelectionRange(0,0);
      }
      deleteMode.current = false;      
      focusIndex.current = null;
      parentId.current = null;
    }
    else if(backSpaceMode.current) {
      let inputChainId = "#input-chain-" + parentId.current + focusIndex.current;
      let elementFocus = $(inputChainId);
      if(elementFocus.length>0) {
        elementFocus[0].focus();
        elementFocus[0].setSelectionRange(0,0);
      }
      backSpaceMode.current = false;      
      focusIndex.current = null;
      parentId.current = null;
    }
  }, [formulaToEditObject]);
 
  useEffect(() => {
    if(queueKeyEvents.length>0 && checkQueue) {
      let focusedElement = $(":focus");
      let newQueueKeyEvents = JavascriptUtilsTooling.deepCopy(queueKeyEvents);
      let charQueue = newQueueKeyEvents.shift();
      setQueueKeyEvents(newQueueKeyEvents);
      if(focusedElement.length>0) {
        let newEvent = {}
        let oldSelection = 0;
        newEvent.currentTarget = focusedElement[0];
        oldSelection = newEvent.currentTarget.selectionStart;
        if(oldSelection==0) {
          newEvent.currentTarget.value = charQueue + newEvent.currentTarget.value;
        }
        else {
          newEvent.currentTarget.value = newEvent.currentTarget.value + charQueue;
        }
        newEvent.currentTarget.selectionStart = oldSelection + 1;
        handleOnChangeInner(newEvent);
      }
      setCheckQueue(false);
    }    
    if(queueKeyEvents.length==0) {      
      isHoldingKey.current = false;
    }
  }, [checkQueue,queueKeyEvents]);
  
  const handleOnClick = (event) => {
    if (!isHoldingKey.current) {
      let inputChainIndex = +event.currentTarget.dataset.inputchainindex;
      let inputChainId = "#input-chain-" + event.currentTarget.dataset.parentid;
      let startPosition = event.currentTarget.selectionStart;
      let inputChainIdRight = inputChainId+(inputChainIndex+1);
      let elementRight = $(inputChainIdRight);
      if(startPosition==1 && elementRight.length>0) {
        elementRight[0].focus();
        elementRight[0].setSelectionRange(0,0);
      }
    }
  };
  
  const handleGoToEditEntityFormula = (event) => {
    if (formulaEditorEditingEntityId) {
      let paramIndex = event.currentTarget.dataset.paramindex;
      let logicalIndex = event.currentTarget.dataset.logicalindex;
      let entityParamId = "#entity_param_" + formulaEditorEditingEntityId + "_" + paramIndex + "-";
      if(logicalIndex) {
        entityParamId = entityParamId + "0_" + logicalIndex + "-";
      }
      let element = $(entityParamId + " > .formula_editor_editor_input_inner > .formula_editor_row_element_end:last-child input");
      if(element.length>0) {
        element[0].focus();
        element[0].animate({
            backgroundColor: "#ccc"
        }, 500, function() {
          element[0].animate({
              backgroundColor: "#fff"
          }, 500);
        });
      }
    }
  };  
  
  const handleChangeShowMarkLabels = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    setShowMarkLabels(value);
  };
  
  let formulaInputBehaviourFunctions = {
    onDragOver: onDragOver,
    onDragEndOnTarget: onDragEndOnTarget,
    onMouseOutEditorElement: onMouseOutEditorElement,
    handleOnChangeInner: handleOnChangeInner,
    handleFormulaCursorDown: handleFormulaCursorDown,
    handleFormulaCursorUp: handleFormulaCursorUp,
    handleOnClick: handleOnClick,
    handleCopyPaste: handleCopyPaste,
    onClickFormulaEditorAction: onClickFormulaEditorAction
  };
  
  const getErrorClassMark = (entity) => {
    if(formulaToEditObject.invalid && formulaToEditObject.error_column==(entity.childs[0].end_index+3)) {
      return " formula_editor_error_element_mark";
    }
    return "";
  };

  const getErrorClass = (entity) => {
    if(formulaToEditObject.invalid && formulaToEditObject.error_column>entity.start_index && formulaToEditObject.error_column<=entity.end_index) {
      return " formula_editor_error_element";
    }
    return "";
  };
  
  const getErrorClassChar = (index, parentFormulaStartIndex) => {
    if(formulaToEditObject.invalid && (parentFormulaStartIndex+index) == formulaToEditObject.error_column) {
      return " formula_editor_error_element_char";
    }
    return "";
  }; 
  
  const printFormulaArray = (formulaArray, parentId, editingEntityBlocked, negation = false, onlyAcceptOneObject = null, notWrapper = false, parentFormulaStartIndex = 0) => {
    let inputsChainCounter = 0;
    let notDisplayLastInput = false;
    let extraIndexAccumulated = 0;
    let nexTextraIndexAccumulated = 0;
    let numberState=false;
    let numberBuffer=[];
    let innerContent = (
      <React.Fragment>
        {negation && (<div className="editor_input_object_inner_param_negation">{"!"}</div>)}
        {formulaArray.map((item, index) => {          
          extraIndexAccumulated = nexTextraIndexAccumulated;
          nexTextraIndexAccumulated += ((typeof item !== 'string') && ("start_index" in item) && ("end_index" in item)) ? item.end_index-item.start_index : 0;
          if(typeof item === 'string') {
            inputsChainCounter += 1;
            let isNumber = /^[.0-9]$/.test(item);
            let nextItem = formulaArray.length-1 == index ? null : formulaArray[index+1]; 
            let nextIsNumber = (nextItem == null || (typeof nextItem !== 'string')) ? false : /^[.0-9]$/.test(nextItem);
            let stringElement = (                
              <FormulaInput 
                key={"s"+index}
                index={index}
                parentId={parentId}
                inputsChainIndex={inputsChainCounter-1}
                test={index+parentFormulaStartIndex+extraIndexAccumulated}
                value={item}
                disabled={editingEntityBlocked}
                disabledOnlyInput={blockInputsDragAndEdit || formulaToEditObject.onlyRead}
                className={getErrorClassChar(index,parentFormulaStartIndex+extraIndexAccumulated)}
                {...formulaInputBehaviourFunctions}
              />
            );
            if(isNumber && !numberState) {
              numberState = true;
              numberBuffer = [];
            }
            if(numberState) {
              numberBuffer.push(stringElement);
              if(!nextIsNumber) {
                numberState = false;
                return (
                  <div className="formula_editor_editor_input_number_wrapper" key={"sn"+index}>
                    {numberBuffer}
                  </div>
                );
              }
            }
            else {
              return stringElement;
            }
          }
          else if(item.type == Constants.formulaEditor.otherObjectTypes.logical) {
            let entityId = parentId+index;
            let newParentId0 = FormulaUtilsTooling.getParentId(parentId, index, 0);
            let newParentId1 = FormulaUtilsTooling.getParentId(parentId, index, 1);
            notDisplayLastInput =  true;
            if(item.is_function) {
              return (
                <div className="formula_editor_logical_expression_wrapper" key={"b" + index}>
                  {printFormulaArray(item.childs[0].content, newParentId0, editingEntityBlocked, false, {
                    entityTypes: ["Function"],
                    ids: [EngineFunctionsDefinition.functionsList.AND.code, EngineFunctionsDefinition.functionsList.OR.code]
                  }, false, item.childs[0].param_formula_start_index)}
                </div>
              );
            }
            return (
              <div className="formula_editor_logical_expression_wrapper" key={"b" + index}>
                <div className={"editor_input_object_inner_param_inner_left"} id={"entity_param_" + newParentId0}>
                  {printFormulaArray(item.childs[0].content, newParentId0, editingEntityBlocked, false, null, false, item.childs[0].param_formula_start_index)}
                </div>
                {(item.comparator != Constants.selectKeys.formulaEditor.logicalComparators.oneterm) && (
                  <div className={"editor_input_object_inner_param_inner_comparator"}>
                    {item.comparator}
                  </div>
                )}
                {(item.childs.length>1) && (
                  <div className={"editor_input_object_inner_param_inner_right"} id={"entity_param_" + newParentId1}>
                    {(item.childs[1].type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING) ? (
                      <div className="editor_input_object_inner_param_string">{item.childs[1].content[0]}</div>
                    ) : printFormulaArray(item.childs[1].content, newParentId1, editingEntityBlocked, false, null, false, item.childs[1].param_formula_start_index)}
                  </div>
                )}
              </div>
            );
          }
          else if(item.type == Constants.formulaEditor.otherObjectTypes.logicalDimension) {
            let entityId = parentId+index;
            let newParentId0 = FormulaUtilsTooling.getParentId(parentId, index, 0);
            let newParentId1 = FormulaUtilsTooling.getParentId(parentId, index, 1);
            notDisplayLastInput =  true;
            if(item.is_function) {
              return (
                <div className="formula_editor_logical_expression_wrapper" key={"b" + index}>
                  {printFormulaArray(item.childs[0].content, newParentId0, editingEntityBlocked, false, {
                    entityTypes: ["Function"],
                    ids: [EngineFunctionsDefinition.functionsList.DIMENSIONRANGE.code]
                  }, false, item.childs[0].param_formula_start_index)}
                </div>
              );
            }
            return (
              <div className="formula_editor_logical_expression_wrapper" key={"b" + index}>
                <div className="formula_editor_logical_expression_label">
                  {<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.dimensionLabel"/>}
                </div>
                {(item.comparator != Constants.selectKeys.formulaEditor.logicalComparators.oneterm) && (
                  <div className={"editor_input_object_inner_param_inner_comparator"}>
                    {" "+item.comparator}
                  </div>
                )}
                {(item.childs.length>1) && (
                  <div className={"editor_input_object_inner_param_inner_right"} id={"entity_param_" + newParentId1}>
                    {(item.childs[1].type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING) ? (
                      <div className="editor_input_object_inner_param_string">{item.childs[1].content[0]}</div>
                    ) : printFormulaArray(item.childs[1].content, newParentId1, editingEntityBlocked, false, null, false, item.childs[1].param_formula_start_index)}
                  </div>
                )}
              </div>
            );
          }
          else if(item.type == "Function" && item.name == Constants.formulaEditor.markCode) {
            inputsChainCounter += 1;
            let entityId = parentId+index;
            let isSelectedEntity = entityId==formulaEditorEditingEntityId;
            let newParentId0 = FormulaUtilsTooling.getParentId(parentId, index, 0);
            let newEditingEntityBlocked = isSelectedEntity ? false : editingEntityBlocked;
            return (
              <React.Fragment key={"b" + index}>
                <FormulaInput
                  className={"formula_editor_row_element_start" + getErrorClassChar(index,parentFormulaStartIndex+extraIndexAccumulated)}
                  index={index}
                  parentId={parentId}
                  inputsChainIndex={inputsChainCounter-1}
                  value={""}
                  disabled={editingEntityBlocked}
                  disabledOnlyInput={blockInputsDragAndEdit || formulaToEditObject.onlyRead}
                  onlyLeft={true}
                  {...formulaInputBehaviourFunctions}
                />
                <div
                  className={"formula_editor_row_element formula_editor_row_element_mark formula_editor_row_element_mark_left" +
                    (isSelectedEntity ? " formula_editor_row_element_mark_selected" : "") +
                    (showMarkLabels ? " formula_editor_row_element_mark_show_labels" : "") +
                    getErrorClassMark(item)}
                  onClick={onClickEntity}
                  data-entityid={entityId}
                  data-mark={"true"}
                  data-markleft={"true"}
                  id={"entity-mark-left" + entityId}
                  title={item.mark_name}
                >
                  {(item.childs && item.childs[0].content.length>0) && (
                    <i 
                      data-entityid={entityId}
                      className={"editor_mark_inner_collapse fas fa-" + (item.collapse ? "plus-square" : "minus-square")}
                      onClick={handleChangeCollapseEntity}
                    />  
                  )}
                  {showMarkLabels && (<div title={item.mark_name} className={"formula_editor_row_element_mark_label"}>{item.mark_name}</div>)}
                  <React.Fragment>                                      
                    {"("}
                  </React.Fragment> 
                </div>
                {(!item.collapse) && (
                  printFormulaArray(item.childs[0].content, newParentId0, newEditingEntityBlocked, false, null, true, item.childs[0].param_formula_start_index)
                )}
                {((item.childs && item.childs[0].content.length>0) && item.collapse && !isSelectedEntity) && (
                  <div className="formula_editor_row_element_mark_hidden_placeholder" data-entityid={entityId} onClick={handleChangeCollapseEntity}>
                    . . .
                  </div> 
                )}
                <div
                  className={"formula_editor_row_element formula_editor_row_element_mark formula_editor_row_element_mark_right" + (isSelectedEntity ? " formula_editor_row_element_mark_selected" : "")}
                  onClick={onClickEntity}
                  data-entityid={entityId}
                  data-mark={"true"}
                  data-markright={"true"}
                  id={"entity-mark-right" + entityId}
                  title={item.mark_name}
                >{")"}</div>
              </React.Fragment>
            );
          }
          else {
            inputsChainCounter += 1;
            let entityId = parentId+index;
            let isSelectedEntity = entityId==formulaEditorEditingEntityId;
            let entityName = (item.type != "Function") ? item.name : LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionNames." + item.name}));
            let entityTitle = ((item.type != "Function") ? (intl.formatMessage({id:"polynomialAdmin.formulaEditor.typeLetter." + item.type + (
              (item.is_table ? "T" : 
              (item.metricType==Constants.metricAdmin.metricType.DYNAMIC ? "D" :
              (item.metricType==Constants.metricAdmin.metricType.VIRTUAL ? "V" : "")))
            )}) + ": ") : "") 
              + entityName;
            let atLeastOneChild = item.childs && item.childs.find(check_empty_child => (check_empty_child.type != Constants.selectKeys.formulaEditor.formulaParamTypes.EMPTY && check_empty_child.type!=""));
            let isMetricInOperatorFakeFunction = (item.type=="Function" && item.name == EngineFunctionsDefinition.functionsList.IN_METRIC_INCLUDES_FAKE_FUNCTION.code);
            let isDimensionRangeFunction = (item.type=="Function" && item.name == EngineFunctionsDefinition.functionsList.DIMENSIONRANGE.code);
            if(isMetricInOperatorFakeFunction || isDimensionRangeFunction) {
              notDisplayLastInput = true;
            }
            return (
              <React.Fragment key={"b" + index}>
                {(onlyAcceptOneObject==null && !isMetricInOperatorFakeFunction) && (
                  <FormulaInput
                    className={"formula_editor_row_element_start" + getErrorClassChar(index,parentFormulaStartIndex+extraIndexAccumulated)}
                    index={index}
                    parentId={parentId}
                    inputsChainIndex={inputsChainCounter-1}
                    value={""}
                    disabled={editingEntityBlocked}
                    disabledOnlyInput={blockInputsDragAndEdit || formulaToEditObject.onlyRead}
                    onlyLeft={true}
                    {...formulaInputBehaviourFunctions}
                  />
                )}
                <div className={"formula_editor_row_element formula_editor_row_element_object" + getErrorClass(item)}>
                  <div className={"editor_input_object editor_input_type_" + item.type + (item.is_table ? " " + item.type + "T" : "") + (item.virtual_calculation ? " " + "CalculationMetric" : "") + (isSelectedEntity ? " editor_input_object_editing" : "") + ((item.error_type || item.round_type) ? " editor_input_object_with_error_type" : "")}>
                    <div
                      className={"editor_input_object_inner"}
                      onClick={item.type != "Dimension" ? onClickEntity : null}
                      data-entityid={entityId}
                      id={"entity" + entityId}
                    >
                      {(!isSelectedEntity && item.childs && atLeastOneChild && item.type != "Dimension") && (
                        <i 
                          data-entityid={entityId}
                          className={"editor_input_object_inner_collapse fas fa-" + (item.collapse ? "plus-square" : "minus-square")}
                          onClick={handleChangeCollapseEntity}
                        />
                      )}
                      <div title={entityTitle} className={"editor_input_object_inner_name"}>
                        {entityTitle}
                      </div>
                      {(item.reducer) && (
                        <div className="editor_input_object_inner_reducer">
                          {((onlyAcceptOneObject && (onlyAcceptOneObject.metricBehaviour == Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC || onlyAcceptOneObject.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC)) ? "" : intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.metricReducersSelectValues." + item.reducer})) + 
                            (item.object_definition ? " (" + intl.formatMessage({id:"polynomialAdmin.formulaEditor.object"}) + ")": "")}
                        </div>
                      )}
                      {(item.error_type) && (
                        <div className="editor_input_object_inner_error_type">
                          {intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.errorTypesSelect." + item.error_type})}
                        </div>
                      )}
                      {(item.round_type) && (
                        <div className="editor_input_object_inner_error_type">
                          {intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.roundTypesSelect." + item.round_type})}
                        </div>
                      )}
                    </div>
                    {(item.childs && (!item.collapse || isSelectedEntity)) && item.childs.map((paramItem, paramIndex) => {
                      let newParentId = FormulaUtilsTooling.getParentId(parentId, index, paramIndex);
                      let newEditingEntityBlocked = entityId==formulaEditorEditingEntityId ? false : editingEntityBlocked;
                      newEditingEntityBlocked = paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.CONTEXT_DIMENSION ? true : newEditingEntityBlocked;
                      let negationComponent = paramItem.negation == "true" ? (<div className="editor_input_object_inner_param_negation">{"!"}</div>) : null;
                      if(paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.EMPTY || paramItem.type == "") {
                        return null;
                      }
                      let paramOnlyAcceptOneObject = null;
                      if(item.type=="Function" && (item.name == EngineFunctionsDefinition.functionsList.SUMX.code || item.name == EngineFunctionsDefinition.functionsList.REDUCEX.code) && paramIndex==0) {
                        paramOnlyAcceptOneObject = {
                          entityTypes: ["Metric", "Function"],
                          ids: [EngineFunctionsDefinition.functionsList.CALENDAR.code],
                          metricBehaviour: Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC
                        };
                      }
                      else if(item.name == EngineFunctionsDefinition.functionsList.LOADMETRIC.code && paramIndex==0){
                        paramOnlyAcceptOneObject = {
                          entityTypes: ["Metric"],
                          exclude_virtual_metric_calculation: true,
                          metricBehaviour: Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC
                        };
                      }
                      //else if para load metric, definir el nuevo parámetro
                      
                      return (
                        <div key={paramIndex} className={"editor_input_object_inner_param_inner" + getErrorClass(paramItem)} id={"entity_param_" + newParentId}>
                          {paramItem.name && (<div className="editor_input_object_inner_param_name">{paramItem.name}</div>)}
                          <div className="editor_input_object_inner_param_name_extender">{paramItem.name ? paramItem.name : "-"}</div>
                          {(paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && item.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && paramIndex==0 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"common.entities." + paramItem.content[0]}))}</div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && item.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && paramIndex==1 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{intl.formatMessage({id:"common.entities.attributes." + item.childs[0].content[0] + "." + paramItem.content[0]})}</div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && item.name == EngineFunctionsDefinition.functionsList.VALIDATEBYSYSTEMDIMENSION.code && paramIndex==0 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"common.entities." + paramItem.content[0]}))}</div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && item.name == EngineFunctionsDefinition.functionsList.EXTRACTDATE.code && paramIndex==1 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.extractDateTypesValues." + paramItem.content[0]})}</div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && item.name == EngineFunctionsDefinition.functionsList.CALENDAR.code && paramIndex==0 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{(calendarsList && calendarsList.find(calendarItem => calendarItem.id==paramItem.content[0])) ? calendarsList.find(calendarItem => calendarItem.id==paramItem.content[0]).extended_name : paramItem.content[0]}</div>
                          )  : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && item.name == EngineFunctionsDefinition.functionsList.CALENDAR.code && paramIndex==3 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.calendarDayTypesValues." + paramItem.content[0]})}</div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && item.name == EngineFunctionsDefinition.functionsList.REDUCEX.code && paramIndex==2 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.reduceXTypes." + paramItem.content[0]})}</div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && item.name == EngineFunctionsDefinition.functionsList.INFOX.code && paramIndex==1 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.infoXTypes." + paramItem.content[0]})}</div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING && (item.name == EngineFunctionsDefinition.functionsList.COLX.code || item.name == EngineFunctionsDefinition.functionsList.PRECOLX.code) && paramIndex==1 && paramItem.content[0] && item.childs[0].content[0] && item.childs[0].content[0] == intl.formatMessage({id: "calendarAdmin.calendarMetricName"})) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{intl.formatMessage({id:"calendarAdmin.calendarMetricAttributes." + paramItem.content[0]})}</div>
                          ) : (item.name == EngineFunctionsDefinition.functionsList.DIMENSIONRANGE.code && paramIndex==0 && paramItem.content[0]) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.dimensionRangeOperatorTypes." + paramItem.content[0]})}</div>
                          )  : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING) ? (
                            <div className="editor_input_object_inner_param_string">{negationComponent}{paramItem.content[0]}</div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.ALL) ? (
                            <div className="editor_input_object_inner_param_all">
                              {negationComponent}
                              {intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues.all"})}
                            </div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.systemDimensionParamTypes.ALL_ACTIVE) ? (
                            <div className="editor_input_object_inner_param_all">
                              {intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValuesLabels.all_active"})}
                            </div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.formulaParamTypes.METRIC_VALUE) ? (
                            <div className="editor_input_object_inner_param_metric_value">
                              {intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues.metric_value"})}
                            </div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.optionsToSetDimensionTypes.HISTORIC_PERIODS && item.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && paramIndex==2) ? (
                            <div className="editor_input_object_inner_param_string">
                              {intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.historic_periods_labels.historic_attribute_function" }) + ": " + paramItem.content[0].period_limit}
                            </div>
                          ) : (paramItem.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS) ? (
                            <div className="editor_input_object_inner_param_string">
                              {intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.historic_periods_labels.historic" }) + ": " + paramItem.content[0].period_limit + 
                                (paramItem.content[0].ignore_actual ? " - " + intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.historic_periods_labels.ignore_actual" }) : "") +
                                (paramItem.content[0].ignore_empty ? " - " + intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.historic_periods_labels.ignore_empty" }) : "") +
                                (paramItem.content[0].series ? " - " + intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.historic_periods_labels.serie" }) + ": " + paramItem.content[0].series : "")
                              }
                            </div>
                          ) : printFormulaArray(paramItem.content, newParentId, newEditingEntityBlocked, paramItem.negation == "true", paramOnlyAcceptOneObject, false, paramItem.param_formula_start_index)}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </React.Fragment>
            );
          }
        })}
        {(!notDisplayLastInput && (onlyAcceptOneObject==null || formulaArray.length==0)) && (
          <FormulaInput
            className={"formula_editor_row_element_end" + getErrorClassChar(formulaArray.length,parentFormulaStartIndex+nexTextraIndexAccumulated)}
            index={formulaArray.length}
            parentId={parentId}
            inputsChainIndex={inputsChainCounter}
            value={""}
            disabled={editingEntityBlocked}
            disabledOnlyInput={blockInputsDragAndEdit || formulaToEditObject.onlyRead}
            onlyLeft={true}
            onlyAcceptOneObject={onlyAcceptOneObject}
            {...formulaInputBehaviourFunctions}
          />
        )}
      </React.Fragment>
    );
    if(notWrapper) {
      return innerContent;      
    }
    else {
      return (<div className="formula_editor_editor_input_inner">{innerContent}</div>)
    }
  };
  
  let extraLabel = (formulaToEditObject && formulaToEditObject.label) ? formulaToEditObject.label : "";
  let editingEntityReturnObject = FormulaUtilsTooling.getEditingEntity(formulaToEditObject, formulaEditorEditingEntityId, false, true);
  let editingEntity = editingEntityReturnObject ? editingEntityReturnObject.entity : null;
  let editingEntityOptions = editingEntityReturnObject ? editingEntityReturnObject.options : null;
  let isEditingEntity = editingEntity ? true : false;
  let blockInputsDragAndEdit = markModeData!=null || cutData != null || copyData != null || isPasting!=null;
  let onlyAcceptOneMetric = (formulaEditorOptions && formulaEditorOptions.formulaType==Constants.formulaEditor.formulaTypes.METRIC) ? 
        { entityTypes: ["Metric"], metricBehaviour: Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC } : null;
  let showFormulaView = !notRender && popupState && popupState.show && formulaToEditObject && formulaToEditObject.formulaArray;
  let finalFunctionsList = [];
  if(showFormulaView) {
    if(formulaEditorOptions.formulaType==Constants.formulaEditor.formulaTypes.METRIC) {
      finalFunctionsList = functionsList.filter(funtionItem => (
        funtionItem.id == EngineFunctionsDefinition.functionsList.IN_METRIC_INCLUDES_FAKE_FUNCTION.code || 
        funtionItem.id == EngineFunctionsDefinition.functionsList.IFERROR.code)); 
    }
    else {
      finalFunctionsList = functionsList.filter(funtionItem => (!formulaEditorOptions.disableFunctions.includes(funtionItem.id) && !funtionItem.hide));      
    }
  }
  return (
    <GlassPopup
      className={"form_popup formula_editor_popup full_screen_popup" + (blockInputsDragAndEdit ? " formula_editor_popup_function_mode" : "") + ((formulaToEditObject && formulaToEditObject.onlyRead) ? " formula_editor_popup_only_read" : "")}
      title={intl.formatMessage({id:"polynomialAdmin.formulaEditor.title"}) + ": " + extraLabel}
      buttonText={(<FormattedMessage id={"polynomialAdmin.formulaEditor.validateAndSetButton"}/>)}
      handleAlternativeButton={(formulaToEditObject && !formulaToEditObject.onlyRead) ? handleShowPopup : null}
      alternativeButtonText={(<FormattedMessage id={"polynomialAdmin.formulaEditor.cancelButton"}/>)}
      {...props}
      handleButton={(formulaToEditObject && !formulaToEditObject.onlyRead) ? handleValidateAndSet : null}
    >
      {(showFormulaView) && (
        <div className="formula_editor_popup_inner">
          <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
            {!(formulaToEditObject.onlyRead || formulaEditorHideDraggables) && (
              <div className={"formula_editor_popup_left_panel" + (formulaEditorHideDraggables ? " formula_editor_popup_left_panel_hidden" : "")}>                
                <DraggableList
                  list={metricsList.map(metricItem => {
                    let entityTitle = intl.formatMessage({id:"polynomialAdmin.formulaEditor.typeLetter.Metric" + 
                       (metricItem.virtual_calculation ? "C" :
                       (metricItem.metric_type==Constants.metricAdmin.metricType.DYNAMIC ? "D" :
                       (metricItem.metric_type==Constants.metricAdmin.metricType.VIRTUAL ? "V" : "")))}) +
                      ": " + metricItem.name; 
                    return {...metricItem, auxName: entityTitle, extraClass: metricItem.virtual_calculation ? "CalculationMetric" : null};
                  })}
                  labelLocale={intl.formatMessage({id:"polynomialAdmin.formulaEditor.metricsLabel"})}
                  searchTextLocale={intl.formatMessage({id:"polynomialAdmin.formulaEditor.metricsSearch"})}
                  idAccesor={"id"}
                  labelAccesor={"auxName"}
                  disabled={blockInputsDragAndEdit}
                  objectType={Constants.formulaEditor.objectTypes.metric}
                />
                {(formulaEditorOptions.formulaType!=Constants.formulaEditor.formulaTypes.METRIC) && (
                  <DraggableList
                    list={polynomialsList.map(polynomialItem => {
                      let entityTitle = intl.formatMessage({id:"polynomialAdmin.formulaEditor.typeLetter.Polynomial" + (polynomialItem.is_table ? "T" : "")}) + ": " + polynomialItem.name; 
                      return {...polynomialItem, auxName: entityTitle, extraClass: polynomialItem.is_table ? "PolynomialT" : null};
                    })}
                    labelLocale={intl.formatMessage({id:"polynomialAdmin.formulaEditor.polynomialsLabel"})}
                    searchTextLocale={intl.formatMessage({id:"polynomialAdmin.formulaEditor.polynomialsSearch"})}
                    idAccesor={"id"}
                    labelAccesor={"auxName"}
                    disabled={blockInputsDragAndEdit}
                    objectType={Constants.formulaEditor.objectTypes.polynomial}
                  />
                )}
                <DraggableList
                  list={finalFunctionsList}
                  labelLocale={intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionsLabel"})}
                  searchTextLocale={intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionsSearch"})}
                  idAccesor={"id"}
                  labelAccesor={"name"}
                  disabled={blockInputsDragAndEdit}
                  objectType={Constants.formulaEditor.objectTypes.function}
                />
              </div>
            )}
            <div className="formula_editor_popup_main_panel">
              <div className="formula_editor_popup_control_buttons">
                {!formulaToEditObject.onlyRead && (
                  <div
                   className={"formula_editor_popup_hide_left_panel_button" + (formulaEditorHideDraggables ? " formula_editor_popup_hide_left_panel_button_hidden" : "")} 
                   onClick={handleHideEditorDraggables}
                   title={formulaEditorHideDraggables ? intl.formatMessage({id:"polynomialAdmin.formulaEditor.showDraggablesLabel"}) : intl.formatMessage({id:"polynomialAdmin.formulaEditor.hideDraggablesLabel"})}
                   >
                    <i className={"fas "+ (formulaEditorHideDraggables ? "fa-eye" : "fa-eye-slash")}></i>
                  </div>
                )}
                {!formulaEditorOptions.disableMarkMode && (
                  <CheckBox 
                    className={"formula_editor_popup_control_buttons_show_mark_labels" + (formulaEditorHideDraggables ? " formula_editor_popup_control_buttons_show_mark_label_hidden_draggables" : "")}
                    value={showMarkLabels}
                    onChange={handleChangeShowMarkLabels}
                    labelLocale={(<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.showMarkLabels"/>)}
                  />
                )}
                {false && (<Button
                  className={"formula_editor_popup_control_buttons_button"}
                  onClick={handleImportFormulaGrammarPopup}
                  data-action={"import"}
                  disabled={isEditingEntity || copyData != null || cutData != null || markModeData != null || isPasting != null}
                  labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.importGrammarLabel"/>}
                />)}
                {(!formulaEditorOptions.disableMarkMode && !formulaToEditObject.onlyRead) && (
                  <Button
                    className={"formula_editor_popup_control_buttons_button" + (markModeData != null ? " formula_editor_popup_control_buttons_button_cancel" : "")}
                    onClick={handleControlButtons}
                    data-action={"mark_mode"}
                    disabled={isEditingEntity || cutData != null || copyData != null || isPasting != null}
                    labelLocale={markModeData == null ? (<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.createMarkLabel"/>) : (<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.cancelCreateMarkLabel"/>)}
                  />
                )}
                <Button
                  className={"formula_editor_popup_control_buttons_button" + (copyData != null ? " formula_editor_popup_control_buttons_button_cancel" : "")}
                  onClick={handleControlButtons}
                  data-action={"copy"}
                  disabled={isEditingEntity || cutData != null || markModeData != null || isPasting != null}
                  labelLocale={copyData == null ? (<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.copyLabel"/>) : (<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.cancelCopyLabel"/>)}
                />
                {!formulaToEditObject.onlyRead && (
                  <Button
                    className={"formula_editor_popup_control_buttons_button" + (cutData != null ? " formula_editor_popup_control_buttons_button_cancel" : "")}
                    onClick={handleControlButtons}
                    data-action={"cut"}
                    disabled={isEditingEntity || markModeData != null || copyData != null || isPasting != null}
                    labelLocale={cutData == null ? (<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.cutLabel"/>) : (<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.cancelCutLabel"/>)}
                  />
                )}
                {!formulaToEditObject.onlyRead && (
                  <Button
                    className={"formula_editor_popup_control_buttons_button" + (isPasting != null ? " formula_editor_popup_control_buttons_button_cancel" : "")}
                    onClick={handleControlButtons}
                    data-action={"paste"}
                    disabled={copiedFormula == null || isEditingEntity || cutData != null || copyData != null || markModeData != null}
                    labelLocale={isPasting == null ? (<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.pasteLabel"/>) : (<FormattedMessage id="polynomialAdmin.formulaEditor.topControlsButtons.cancelPasteLabel"/>)}
                  />
                )}
                <span data-collapse={"false"} className="simulated-a" onClick={handleChangeCollapseAllEntity}><FormattedMessage id="polynomialAdmin.formulaEditor.expandAll"/></span>
                <span data-collapse={"true"} className="simulated-a" onClick={handleChangeCollapseAllEntity}><FormattedMessage id="polynomialAdmin.formulaEditor.collapseAll"/></span>
              </div>
              <div className="formula_editor_popup_main_top_panel">
                <div className={"formula_editor_editor_input" + ((formulaToEditObject.invalid) ? " formula_editor_editor_input_error" : "")}>
                  <div className={"formula_editor_editor_input_inner_wrapper" + (isEditingEntity ? " formula_editor_editor_input_inner_wrapper_is_editing" : "")}>
                    {isEditingEntity && (<div className="formula_editor_editor_input_overlay"></div>)}
                    {printFormulaArray(formulaToEditObject.formulaArray,FormulaUtilsTooling.getRootId(), isEditingEntity, false, onlyAcceptOneMetric)}
                  </div>
                </div>
              </div>
              {(editingEntity!=null) && (
                <div className={"formula_editor_popup_main_bottom_panel" + 
                  ((editingEntity.type == "Function" && editingEntity.name == Constants.formulaEditor.markCode) ? " formula_editor_popup_main_bottom_panel_mark" : "")}>
                  <label className="close">
                    <i className="fas fa-times-circle" onClick={onCloseEntityEditor}></i>
                  </label>
                  <div className="formula_editor_editor_entity">
                    {(editingEntity.type == "Polynomial" && !editingEntity.is_table) ? (
                      <FormulaPolynomialEditor
                        dimensionsList={dimensionsList}
                        dimensionInstancesOptions={dimensionInstancesOptions}
                        dimensionInstancesFetch={dimensionInstancesFetch}
                        dimensionInstancesLoading={dimensionInstancesLoading}
                        entity={editingEntity}
                        onChange={onEditEntityEditor}
                        handleGoToEditFormula={handleGoToEditEntityFormula}
                        handleDeleteEntity={handleDeleteEntity}
                        disabled={formulaToEditObject.onlyRead}
                        escBehaviourHandler={escBehaviourHandler}
                      />
                    ) : (editingEntity.type == "Polynomial" && editingEntity.is_table) ? (
                      <FormulaPolynomialTableEditor
                        dimensionsList={dimensionsList}
                        dimensionInstancesOptions={dimensionInstancesOptions}
                        dimensionInstancesFetch={dimensionInstancesFetch}
                        dimensionInstancesLoading={dimensionInstancesLoading}
                        entity={editingEntity}
                        onChange={onEditEntityEditor}
                        handleGoToEditFormula={handleGoToEditEntityFormula}
                        handleDeleteEntity={handleDeleteEntity}
                        disabled={formulaToEditObject.onlyRead}
                        escBehaviourHandler={escBehaviourHandler}
                      />                      
                    ) : (editingEntity.type == "Metric") ? (
                      <FormulaMetricEditor
                        polynomialsList={polynomialsList}
                        dimensionsList={dimensionsList}
                        dimensionInstancesOptions={dimensionInstancesOptions}
                        dimensionInstancesFetch={dimensionInstancesFetch}
                        dimensionInstancesLoading={dimensionInstancesLoading}
                        entity={editingEntity}
                        entityOptions={editingEntityOptions}
                        formulaType={formulaEditorOptions.formulaType}
                        onChange={onEditEntityEditor}
                        handleGoToEditFormula={handleGoToEditEntityFormula}
                        handleDeleteEntity={handleDeleteEntity}
                        disabled={formulaToEditObject.onlyRead}
                        escBehaviourHandler={escBehaviourHandler}
                      />
                    ) : (editingEntity.type == "Function" && editingEntity.name == EngineFunctionsDefinition.functionsList.IN_METRIC_INCLUDES_FAKE_FUNCTION.code) ? (
                      <FormulaInMetricFakeFunctionEditor
                        dimensionsList={dimensionsList}
                        dimensionInstancesOptions={dimensionInstancesOptions}
                        dimensionInstancesFetch={dimensionInstancesFetch}
                        dimensionInstancesLoading={dimensionInstancesLoading}
                        entity={editingEntity}
                        entityOptions={editingEntityOptions}
                        onChange={onEditEntityEditor}
                        handleGoToEditFormula={handleGoToEditEntityFormula}
                        handleDeleteEntity={handleDeleteEntity}
                        disabled={formulaToEditObject.onlyRead}
                        escBehaviourHandler={escBehaviourHandler}
                      />
                    ) : (editingEntity.type == "Function") ? (
                      <FormulaFunctionEditor
                        metricsList={metricsList}
                        marksList={formulaToEditObject.marks_list}
                        entity={editingEntity}
                        entityOptions={editingEntityOptions}
                        calendarsList={calendarsList}
                        onChange={onEditEntityEditor}
                        handleGoToEditFormula={handleGoToEditEntityFormula}
                        handleDeleteEntity={handleDeleteEntity}
                        disabled={formulaToEditObject.onlyRead}
                        escBehaviourHandler={escBehaviourHandler}
                        onMarkEditorExitHandler={onCloseEntityEditor}
                      />
                    ) : null }
                  </div>
                </div>
              )}
            </div>
          </DragDropContext>
        </div>
      )}
    </GlassPopup>
  );
};

export default FormulaEditorPopup;



// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/formulaEditorPopup.jsx